import React from "react";
import { getResponseText } from "./utils";
import SolidSpinnerIcon from "../../assets/icons/SolidSpinnerIcon";
import CheckIcon from "../../assets/icons/CheckIcon";

const getFetchingText = ({ tool_name, tableMetadataLength }) => {
  if (!tool_name) {
    return "Gathering relevant reports to query ";
  }

  if (!tableMetadataLength) {
    return "Generating the query and pulling data for you";
  }
};

const PendingChat = ({
  tableMetadataLength,
  tabsLength,
  status,
  reply,
  userQueryAndReport,
}) => {
  const { tool_name = "", tool_inputs = null } = reply?.tool_usage?.length
    ? reply.tool_usage[0]
    : status === "pending"
    ? userQueryAndReport
    : {};

  return (
    <div>
      {tool_name ? (
        <div className="flex flex-col gap-1 p-2 pt-0 text-zinc-200 w-full rounded-lg">
          <div className="flex items-center gap-4 mb-2">
            {status !== "pending" ? (
              <>
                <div className="p-2 rounded-full bg-zinc-800">
                  <CheckIcon className="w-4 h-4 text-green-500" />
                </div>
                <div className="bg-zinc-800 px-3 py-1.5 w-fit rounded-lg text-sm">
                  {tool_name}
                </div>
              </>
            ) : null}
          </div>
          <div className="flex gap-2 text-sm">
            <h4 className="font-medium min-w-[120px] text-zinc-400">
              User Query:
            </h4>
            <p>{tool_inputs?.userQuery}</p>
          </div>
          <div className="flex gap-2 text-sm">
            <h4 className="min-w-[120px] font-medium text-zinc-400">
              Report To Query:
            </h4>
            <p>
              {Object.keys(tool_inputs?.reportsToQuery)
                .filter((reportQuery) => {
                  return Boolean(tool_inputs?.reportsToQuery[reportQuery]);
                })
                .join(", ")}
            </p>
          </div>
        </div>
      ) : null}
      {!tabsLength ? (
        <div className="flex gap-1 items-center mt-1">
          {status === "pending" ? (
            <div>
              <SolidSpinnerIcon className="w-5 h-5 text-white animate-spin" />
            </div>
          ) : null}
          <div className="text-sm text-justify whitespace-pre-wrap">
            {getResponseText(
              status,
              reply.response_text,
              getFetchingText({ tool_name, tableMetadataLength })
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PendingChat;
